// Runtime env, injected into window.__ENV__ by entrypoint.sh at container
// start (see public/config.js), takes precedence so a single Docker image
// can be deployed unchanged across environments. Falls back to Vite's
// build-time VITE_ vars for local dev (npm run dev/build without Docker).
// 
// npm run build -- --mode <env> : Loads all VITE_* variables from .env.<env> into import.meta.env
const runtimeEnv = window.__ENV__ || {};

function getEnv(key) {
  const value = runtimeEnv[key];
  return value !== undefined && value !== "" ? value : import.meta.env[`VITE_${key}`];
}

export const API_BASE = getEnv("API_BASE")
export const REDIS_URL = getEnv("REDIS_URL")
export const CURRENT_ENV = getEnv("CURRENT_ENV")
export const USE_LOGGER = Boolean(getEnv("USE_LOGGER")?.toLowerCase().trim() == "true")
export const SKIP_AUTH = Boolean(getEnv("SKIP_AUTH")?.toLowerCase().trim() == "true")
export const DEFAULT_SEARCH_SPACE = getEnv("DEFAULT_SEARCH_SPACE")
export const INDEX_NAME = getEnv("INDEX_NAME")
export const MSAL_CONFIG = {
  auth: {
    clientId: getEnv("CLIENT_ID"),
    authority: getEnv("AUTHORITY"),
    redirectUri: getEnv("REDIRECT_URL") ?? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    postLogoutRedirectUri: getEnv("POST_LOGOUT_REDIRECT_URI") ?? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: getEnv("CACHE_LOCATION"),
    storeAuthStateInCookie: Boolean(getEnv("STORE_AUTH_STATE_IN_COOKIE")?.toLowerCase().trim() == "true"),
  },
  system: {
    loggerOptions: USE_LOGGER
      ? {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case "Error":
              console.error(message);
              break;
            case "Info":
              console.info(message);
              break;
            case "Verbose":
              console.debug(message);
              break;
            case "Warning":
              console.warn(message);
              break;
          }
        },
        piiLoggingEnabled: false,
        logLevel: "Info",
      }
      : undefined,
    allowNativeBroker: false,
  },
}

if (USE_LOGGER) {
  console.log(`Environment: ${CURRENT_ENV}`, { API_BASE, MSAL_CONFIG });
}
